function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.22 0H50v49H1.22z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.858 11.637h33.504a6.418 6.418 0 016.418 6.419v22.982H2.44V18.056a6.418 6.418 0 016.419-6.419zM27.37 36.534c2.678.706 5.207-.037 5.648-1.66.442-1.622-1.371-3.51-4.05-4.216-2.677-.706-5.206.036-5.648 1.659-.442 1.622 1.371 3.51 4.05 4.217zm.851-20.581a1.027 1.027 0 00-1.252.723l-1.86 6.831a1.03 1.03 0 00.73 1.263l11.69 3.084a1.027 1.027 0 001.253-.723l1.86-6.832a1.027 1.027 0 00-.73-1.262l-11.69-3.084zM8.103 20.58l3.265 11.996 7.958-2.1-3.265-11.995-7.958 2.099z",
  fill: "#00ACC1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.96 40.517h45.3V18.056a5.898 5.898 0 00-5.898-5.898H8.858a5.898 5.898 0 00-5.898 5.898v22.46zm.12-21.102c3.83 0 6.933-3.094 6.933-6.91m38.254 6.91c-3.828 0-6.932-3.094-6.932-6.91M10.013 40.782c0-3.817-3.104-6.912-6.932-6.912m38.254 6.912c0-3.817 3.104-6.912 6.932-6.912M18.228 11.857V9.603c0-1.244 1.15-2.253 2.568-2.253h10.013c1.418 0 2.567 1.009 2.567 2.253v2.254",
  stroke: "#371447",
  strokeWidth: 1.042
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.532 20.929l3.063 11.397 7.22-1.93L15.752 19l-7.22 1.929z",
  stroke: "#371447",
  strokeWidth: 1.042
}), /*#__PURE__*/React.createElement("ellipse", {
  stroke: "#371447",
  strokeWidth: 1.042,
  transform: "rotate(15 28.356 33.706)",
  cx: 28.356,
  cy: 33.706,
  rx: 5.184,
  ry: 3.062
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.623 16.11a.506.506 0 00-.62.357L25 23.922s0 0 0 0a.506.506 0 00.358.62l12.733 3.402a.506.506 0 00.62-.357l2.004-7.455s0 0 0 0a.506.506 0 00-.359-.62L27.623 16.11z",
  stroke: "#371447",
  strokeWidth: 1.042
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.837 24.244c1.74 1.071 2.853 2.949 3.338 5.631M11.553 30.9l6.652-1.906m-5.29-4.494c-.263-1.185.139-1.953 1.206-2.304M11.83 26.25c-.263-1.184.138-1.952 1.205-2.303m-.455.476c-.703-.853-2.147-.294-2.049.333m2.306-.512c.592-.803 1.277-.976 2.054-.52m-2.571.264c.044-.851-.383-1.278-1.28-1.28",
  stroke: "#371447",
  strokeWidth: 0.665
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.878 32.462l.89 1.38 2.295-1.2 1.109 2.218 1.401-.723.68 2.166c-1.586.599-3.153.671-4.703.217a7.011 7.011 0 01-3.77-2.641l2.098-1.416zm1.735-10.733c.301.123 1.545.448 3.733.973l2.18 3.197.637.151-.408-2.76c1.16.232 1.941.382 2.342.452s.767-.032 1.096-.305l1.402-1.783a1.604 1.604 0 00-.494-.05c-.125.013-.732.352-1.82 1.016l-2.177-.527 1.627-2.157c-.336-.125-.58-.17-.734-.132-.153.036-1.235.579-3.248 1.626l-3.146-.749c-.126-.045-.326-.014-.6.095-.273.11-.478.24-.615.39-.152.252-.077.44.225.563z",
  fill: "#371447"
}));

function SvgVacationMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVacationMd;